import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'

export const getAdminServiceOffers = asBuilder((): { id: number; title: string }[] => {
  return faker.helpers.multiple(() => ({
    id: faker.number.int(),
    title: faker.lorem.sentence(),
  }))
})
